
define('ldsh!modules/expense/edit/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Expense</h1>\n<div class="form form-horizontal" role="form">\n\n\n\n  \n\n  <div class="form-group">\n    <label for="client">client</label>\n    <div class="optionsgrid grid-client"></div>\n  </div>\n\n  \n\n  <div class="form-group">\n    <label for="category">category</label>\n    <div class="optionsgrid grid-category"></div>\n  </div>\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

